
import {
  Component,
  Vue,
  Inject,
  Prop,
  Watch,
  Ref
} from "vue-property-decorator";
import { ElForm } from "element-ui/types/form";
import api from "@/api";
import {
  PayrollRequisitionCreateOrEditDto,
  AuditFlowDto, PaymentCategoryScope
} from "@/api/appService";
import PaymentCategorySelect from "@/components/PaymentCategorySelect/index.vue";
@Component({
  components: {PaymentCategorySelect}
})
export default class EditPayrollRequisition extends Vue {
  @Ref() readonly dataForm!: ElForm;

  get dialogTitle() {
    return this.form!.id ? "编辑" : "新建";
  }

  categories: any[] = [];
  auditFlows: AuditFlowDto[] = [];
  @Watch("show")
  async onShowChange(value: boolean) {
    if (value) {
      await api.payrollRequisition
        .getForEdit({ id: this.form!.id })
        .then(res => {
          this.form = res.data!;
          this.categories = (res.schema as any).categoryId;
          this.auditFlows = (res.schema as any).auditFlows;
        });
    } else {
      this.form = { ...this.defaultData };
    }
    this.$nextTick(() => {
      this.dataForm.clearValidate();
    });
  }

  defaultData: PayrollRequisitionCreateOrEditDto = {
    /** 请款金额 */
    amount: undefined,
    /** 请款说明 */
    summary: undefined,
    /** 分类ID */
    categoryId: undefined,
    /** 凭证的多个附件ID */
    attachments: undefined,
    id: 0
  };

  show = false;
  form: PayrollRequisitionCreateOrEditDto = { ...this.defaultData };

  get scopeFilter(){
    return PaymentCategoryScope.PayrollRequisition;
  }

  async save() {
    console.log(this.form);
    this.dataForm.validate(async (valid: boolean) => {
      if (valid) {
        if (this.form!.id) {
          await api.payrollRequisition.update({ body: this.form });
        } else {
          await api.payrollRequisition.create({ body: this.form });
        }
        this.show = false;
        this.$message.success("更新成功");
        this.$emit("onSave");
      }
    });
  }

  // 图片上传前判断
  // async beforeAvatarUpload(file: any) {
  //   const isLt2M = file.size / 1024 / 1024 < 2;
  //   if (!isLt2M) {
  //     this.$message.error("上传头像图片大小不能超过 2MB!");
  //   }
  //   return isLt2M;
  // }

  // async handleAvatarSuccess(res: any, file: any) {
  //   console.log(res);
  //   if (res.success) {
  //     this.form.titleImageUrl = res.result;
  //   }
  // }

  cancel() {
    this.show = false;
  }

  roleRule = {
    amount: [
      {
        required: true,
        message: "必填",
        trigger: "blur"
      }
    ],
    categoryId: [
      {
        required: true,
        message: "必填",
        trigger: "blur"
      }
    ],
    summary: [
      {
        required: true,
        message: "必填",
        trigger: "blur"
      }
    ],
    remark: [
      {
        required: false,
        trigger: "blur"
      }
    ]
  };
}
